document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      nav.classList.toggle('is-open');
    });
  }

  document.querySelectorAll('.vl-slideshow').forEach(function (root) {
    var track = root.querySelector('[data-track]');
    var slides = track ? Array.from(track.children) : [];
    if (slides.length < 2) return;
    var index = 0;
    var dots = root.querySelector('[data-dots]');
    slides.forEach(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.addEventListener('click', function () { go(i); });
      dots && dots.appendChild(b);
    });
    function paint() {
      slides.forEach(function (s, i) { s.style.opacity = i === index ? '1' : '0'; s.style.pointerEvents = i === index ? 'auto' : 'none'; });
      if (dots) Array.from(dots.children).forEach(function (d, i) { d.classList.toggle('is-on', i === index); });
    }
    function go(i) { index = (i + slides.length) % slides.length; paint(); }
    root.querySelector('[data-prev]') && root.querySelector('[data-prev]').addEventListener('click', function () { go(index - 1); });
    root.querySelector('[data-next]') && root.querySelector('[data-next]').addEventListener('click', function () { go(index + 1); });
    paint();
    if (root.getAttribute('data-autoplay') === 'true') {
      var ms = (parseInt(root.getAttribute('data-speed'), 10) || 6) * 1000;
      setInterval(function () { go(index + 1); }, ms);
    }
  });

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) e.target.classList.add('is-in');
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.vl-anim').forEach(function (el) { io.observe(el); });
  }

  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var target = new Date(el.getAttribute('data-countdown')).getTime();
    function tick() {
      var d = target - Date.now();
      if (d < 0) d = 0;
      var days = Math.floor(d / 86400000);
      var hours = Math.floor((d % 86400000) / 3600000);
      var mins = Math.floor((d % 3600000) / 60000);
      var secs = Math.floor((d % 60000) / 1000);
      var set = function (sel, v) { var n = el.querySelector(sel); if (n) n.textContent = String(v).padStart(2, '0'); };
      set('[data-d]', days); set('[data-h]', hours); set('[data-m]', mins); set('[data-s]', secs);
    }
    tick();
    setInterval(tick, 1000);
  });

  document.querySelectorAll('.vl-swatch').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.parentElement.querySelectorAll('.vl-swatch').forEach(function (b) { b.classList.remove('is-on'); });
      btn.classList.add('is-on');
    });
  });
});
